import * as highcharts from "highcharts";
import "highcharts/modules/map";
import { Component, h } from "preact";

// tslint:disable-next-line
require("highcharts/modules/map")(highcharts);

interface IWorldMapProps {
  data: any[];
  height?: number;
  width?: number;
}

export default class WorldMapChart extends Component<IWorldMapProps> {
  private divElement?: HTMLDivElement;
  private chart?: Highcharts.Chart;
  private reflowIntervalHandle?: number;
  private worldMap: any;

  public async componentDidMount() {
    await this.createChart();

    this.reflowIntervalHandle = window.setInterval(() => {
      if (this.chart !== undefined) {
        this.chart.reflow();
      }
    }, 500);
  }

  public async componentDidUpdate() {
    await this.createChart();
  }

  // Destroy chart before unmount.
  public componentWillUnmount() {
    window.clearInterval(this.reflowIntervalHandle);
    if (this.chart) {
      this.chart.destroy();
    }
  }

  public render(props: IWorldMapProps, state: {}) {
    return (
      <div
        id="container"
        style="height: 100%; width: 100%"
        ref={e => (this.divElement = e as HTMLDivElement)}
      />
    );
  }

  private async createChart() {
    if (this.worldMap === undefined) {
      this.worldMap = await getWorldMap();
    }

    if (this.chart) {
      this.chart.destroy();
    }

    highcharts.setOptions({
      lang: {
        decimalPoint: ".",
        numericSymbols: [" K", " M", " G", " T", " P", "E"],
        thousandsSep: ",",
      },
    });

    const legendOptions: any | undefined = {
      align: "center",
      layout: "horizontal",
      title: "K€",
      verticalAlign: "bottom",
    };
    const seriesMapOptions: Highcharts.SeriesMapOptions = {
      data: this.props.data,
      dataLabels: {
        enabled: false,
      },
      joinBy: (["iso-a3", "code"] as {}) as string,
      mapData: this.worldMap,
      states: {
        hover: {
          enabled: false,
        },
      },
      type: "map",
    };

    const mapOptions: Highcharts.Options = {
      chart: {},
      colorAxis: {
        maxColor: "#226644",
        min: 0,
        minColor: "#caeeda",
      },
      credits: {
        enabled: false,
      },
      legend: legendOptions,
      mapNavigation: {
        enabled: true,
      },
      series: [seriesMapOptions],
      title: {
        text: "",
      },
      tooltip: {
        borderColor: "#ccc",
        footerFormat: "</td></tr></table>",
        headerFormat:
          '<table><tr><td style="color:{series.color};padding:0">{point.key}: </td>',
        pointFormat:
          '<td style="padding:0" align="right"><b>{point.value:,.0f} K€</b>',
        shared: true,
        useHTML: true,
      },
    };

    this.chart = highcharts.mapChart(
      this.divElement as HTMLElement,
      mapOptions
    );
  }
}

export async function getWorldMap() {
  const worldMapFeature = await require("./WorldMapFeature.json");
  return {
    copyright:
      "Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth",
    copyrightShort: "Natural Earth",
    copyrightUrl: "http://www.naturalearthdata.com",
    crs: {
      properties: { name: "urn:ogc:def:crs:EPSG:54003" },
      type: "name",
    },
    features: worldMapFeature.features,
    "hc-transform": {
      default: {
        crs:
          "+proj=mill +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R_A +datum=WGS84 +units=m +no_defs",
        jsonmarginX: -999,
        jsonmarginY: 9851.0,
        jsonres: 15.5,
        scale: 1.70830296554e-5,
        xoffset: -19816494.5204,
        yoffset: 12635908.1982,
      },
    },
    title: "World with Palestine areas, high resolution",
    type: "FeatureCollection",
    version: "1.1.2",
  };
}
